import { Button, ButtonsGroup, Modal, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useAutomaticPaymentRemindersModalForm,
  useTrackAutomaticPaymentReminders,
} from '@features/invoicingSettings/modules/paymentsAndReminders'

interface AutomaticPaymentRemindersModalFooterProps {
  id: string
}

export const AutomaticPaymentRemindersModalFooter = ({
  id,
}: AutomaticPaymentRemindersModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { submitForm, variant } = useAutomaticPaymentRemindersModalForm()
  const { close: closeSendAsEmailModal } = useModal(id)
  const { trackAutomaticPaymentReminders } = useTrackAutomaticPaymentReminders()

  const handleCancelButtonClick = useCallback(() => {
    trackAutomaticPaymentReminders('modal - Cancel button clicked', variant)
    closeSendAsEmailModal()
  }, [closeSendAsEmailModal, trackAutomaticPaymentReminders, variant])

  const handleApplyButtonClick = useCallback(() => {
    trackAutomaticPaymentReminders('modal - Apply button clicked', variant)
    submitForm()
  }, [submitForm, trackAutomaticPaymentReminders, variant])

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button onClick={handleCancelButtonClick} variant="text">
          {t('cancel')}
        </Button>
        <Button onClick={handleApplyButtonClick}>
          {t('settings.organization.external_invoice.automatic_payment_reminders.modal.apply')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
